
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppLayout from '@/components/layout/AppLayout';

interface TabDef {
  value: 'linea' | 'cobranza';
  to: string;
  icon: string;
  title: string;
  subtitle: string;
}

const TABS: TabDef[] = [
  {
    value: 'linea',
    to: '/cartola/linea',
    icon: 'account_balance_wallet',
    title: 'Tu línea',
    subtitle: 'Saldo disponible y movimientos',
  },
  {
    value: 'cobranza',
    to: '/cartola/cobranza',
    icon: 'event_available',
    title: 'Programación de pagos',
    subtitle: 'Próximos cobros de tus adelantos',
  },
];

export default function CartolaPage() {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const current: TabDef['value'] = pathname.endsWith('/cobranza') ? 'cobranza' : 'linea';

  return (
    <AppLayout wide>
      <div className="py-6">
        <h1 className="text-2xl font-semibold text-foreground">Cartola</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Tu línea de adelantos y la programación de cobranza de tus adelantos en curso.
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3" role="tablist" aria-label="Vistas de cartola">
          {TABS.map((tab) => {
            const active = current === tab.value;
            return (
              <button
                key={tab.value}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => navigate(tab.to)}
                className={`group relative flex items-center gap-3 rounded-xl border-2 px-4 py-3 text-left transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
                  active
                    ? 'border-primary bg-primary/5 dark:bg-primary/10 shadow-sm'
                    : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50 dark:border-slate-800 dark:bg-slate-900 dark:hover:border-slate-700 dark:hover:bg-slate-800/50'
                }`}
              >
                <div
                  className={`shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-lg transition-colors ${
                    active
                      ? 'bg-primary text-white shadow-md shadow-primary/20'
                      : 'bg-slate-100 text-slate-500 group-hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:group-hover:bg-slate-700'
                  }`}
                >
                  <span className="material-symbols-outlined text-xl">{tab.icon}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p
                    className={`text-sm font-bold leading-tight ${
                      active ? 'text-primary' : 'text-slate-900 dark:text-white'
                    }`}
                  >
                    {tab.title}
                  </p>
                  <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400 truncate">
                    {tab.subtitle}
                  </p>
                </div>
                {active && (
                  <span
                    aria-hidden="true"
                    className="shrink-0 material-symbols-outlined text-primary text-xl"
                  >
                    arrow_forward
                  </span>
                )}
              </button>
            );
          })}
        </div>

        <div className="mt-6">
          <Outlet />
        </div>
      </div>
    </AppLayout>
  );
}
